import React, { FunctionComponent } from "react";
import { Button } from "@cmsgov/ds-medicare-gov";
import { useTranslate } from "../../helpers";

interface BackNextButtonsProps {
  nextPage: () => void;
  previousPage: () => void;
  hideBackButton?: boolean;
  nextText?: string;
  disableNext?: boolean;
  inReview: boolean;
}

const BackNextButtons: FunctionComponent<BackNextButtonsProps> = ({
  nextPage,
  previousPage,
  hideBackButton,
  inReview,
  nextText,
  disableNext,
}) => {
  const t = useTranslate();

  return (
    <div className="EnrollmentFormPage__buttons">
      {!hideBackButton && !inReview && (
        <Button
          className="EnrollmentFormPage__backButton"
          onClick={previousPage}
        >
          {t("back")}
        </Button>
      )}

      <Button
        variation="primary"
        className="EnrollmentFormPage__nextButton"
        disabled={disableNext}
        onClick={nextPage}
      >
        {nextText || (inReview ? t("save") : t("next"))}
      </Button>
    </div>
  );
};

export default BackNextButtons;
